import { createArrayFromIndexedArray } from '@common/utils/helpers/array/create-array-from-indexed-array';
import { DepotOverload } from '@common/types';

export const depotOverloads2table = (data: Array<DepotOverload>) => {
  return createArrayFromIndexedArray(data).map((item, i) => {
    return {
      ...item,
      key: item.ID ?? 'row' + i
    };
  });
};
